//
//
//
//

import businessUnitManager from "@/Manager/09.Cm/BusinessUnitManager";
import passageUserManager from "@/Manager/09.Cm/PassageUserManager";
export default {
  components: {},
  data() {
    return {};
  },
  async created() {
    this.$appBox.clear(this);
    await businessUnitManager.asyncSetBusinessUnit(this);
    
    const workBenchUrl = "/YslCm/Workbench";
    const bindWechatUrl = "/YslCm/PassageUser/BindWechat";
    var result =  await passageUserManager.getCheckPassageUser(this);
    if(result == 302){
      return;
    }
    if(result == false){
      this.$path.to("/Cm/PassageUser/BindWechat");
      return;
    }

    if(result && result.OpenId){

      var passageUser = result;
      switch (passageUser.PassageUserType) {
        case 13: {
          this.$path.to("/YslCm/SalesOffice/Workbench");
          break;
        }
        case 12: {
          this.$path.to("/YslCm/SalesDept/Workbench");
          break;
        }
        case 11: {
          this.$path.to("/YslCm/SalesArea/Workbench");
          break;
        }
        default:{
          this.$path.to("/YslCm/SalesArea/Workbench");
          break;
        }
      }
      return;

    }
    this.$path.to("/YslCm/PassageUser/BindWechat");
  },

  mounted() {},
  methods: {}
};
